import React from "react";
import { inject, observer } from "mobx-react";
import  { withStyles } from  '@material-ui/core/styles';
import LinearProgress from '@material-ui/core/LinearProgress';
import MUIDataTable from "mui-datatables";
import moment from 'moment';
import * as mobx from 'mobx'

const styles = theme => ({
  root: {
    backgroundColor: '#5DE3FE'
  }
})

//need to show network and price maps sponserships etc
 
const TABLE_COLUMNS = [
  {name: "serviceCaseKey",label: "Case Id",options: {filter: true,sort: true}},
 // {name: "type",label: "Case Type",options: {filter: true, sort: true}},
  {name: "leadPhone",label: "Phone",options: {filter: true,sort: true}},
  {name: "status",label: "Status",options: {filter: true,sort: true}},
  {name: "summary",label: "Summary", options: {filter: true, sort: true }},
  {name: "created",label: "Created",options: {filter: true,sort: true}},
  {name: "refundType",label: "Refund Type",options: {filter: true,sort: true}},
  {name: "amount",label: "Refunded Amount",options: {filter: true,sort: true}},
]


@inject("commonStore")
@inject("authStore")
@observer
class Refunds extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      title: 'Support Requests',
      columns: TABLE_COLUMNS,
      loading: false,
    }
  }
  async componentDidMount() {
    console.log('componentDidMount')
    this.getItems()
  }

    
  refreshItems = () => {
    this.getItems()
  }

  getItems = () => {
    const { authStore } = this.props
    console.log('getItems getSupportCases')
    this.setState({loading: true})
    return authStore.getSupportCases()
    .then(result => {
      if(result){
          this.setState({loading: false, successLoad: true})
      }else{
        this.setState({loading: false, successLoad: false})
      }
    })
  }


  createDataArray = () => {
    const { columns } = this.state 
    const { supportCases } = this.props.commonStore

  
    return supportCases.map(item => {
   
      const valueArray = []
      for(let column of columns){
        const { name } = column
        if(name === 'created'){
          const date = moment(item[name]).format('MM/DD/YY')
          valueArray.push(date)
        }else{
          valueArray.push(item[name])
        }
      }

      return valueArray
    })


  }
  
  render() {
    const { loading, columns, title, selectedItem, showForm, showSetupForm, startDate, endDate, showCampaignDialog, selectedCampaign, showCampaignFailDialog } = this.state 
    const { classes, commonStore } = this.props
    const { setSupportCaseRowsPerPage, supportCaseRowsPerPage, network } = commonStore

    console.log('loading')
    console.log(loading)

    const supportCases = this.createDataArray()
    console.log(supportCases)

    const options = {
      filterType: 'checkbox',
      selectableRows: false,
     // onRowClick:this.itemSelected,
      print: false,
      download: false,
      downloadOptions: false,
      rowsPerPage: supportCaseRowsPerPage > 0 ? supportCaseRowsPerPage : supportCases.length,
      onChangeRowsPerPage:setSupportCaseRowsPerPage
    };

    if(loading){
     return <LinearProgress color="secondary" />
    }

    return (
        <div className={classes.root}>
          <MUIDataTable
          title={'Support Cases'}
          data={supportCases}
          viewColumns={true}
          columns={columns}
          options={options}
        />

        {/*showCampaignDialog ? <CampaignBalanceDialog loading={loading} open={showCampaignDialog} campaign={selectedCampaign} update={this.updateCampaignBalance} redirect={() => this.editCampaign(selectedCampaign)} close={this.closeCampaignDialog}/> : null*/}
        </div>
      );
    }
  }

  export default withStyles(styles)(Refunds);

  


// WEBPACK FOOTER //
// ./src/components/Leads/Support/index.js